import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import { formatViews, getTypeName } from "@/utils/video";

interface HotRankingProps {
  videos: Video[];
}

export default function HotRanking({ videos }: HotRankingProps) {
  return (
    <aside className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-100 px-5 py-4">
        <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
          <i className="ri-fire-fill text-accent-500"></i>
          热门排行
        </h2>
        <span className="text-xs text-foreground-400">按浏览量</span>
      </div>
      <ol className="divide-y divide-background-100">
        {videos.map((video, index) => {
          const rank = index + 1;
          return (
            <li key={video.id}>
              <Link
                to={`/detail/${video.id}`}
                className="group flex items-center gap-3 px-5 py-3 transition-colors hover:bg-background-100"
              >
                <span
                  className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-bold ${
                    rank <= 3
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-100 text-foreground-500"
                  }`}
                >
                  {rank}
                </span>
                <span className="h-11 w-16 shrink-0 overflow-hidden rounded-md bg-background-100">
                  <img
                    src={video.cover}
                    alt={`${video.title}封面`}
                    title={`${video.title} - 污视频热门排行`}
                    className="h-full w-full object-cover object-top"
                  />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-accent-600">
                    {video.title}
                  </span>
                  <span className="mt-0.5 flex items-center gap-2 text-xs text-foreground-400">
                    <span>{getTypeName(video.type)}</span>
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line"></i>
                      {formatViews(video.views)}
                    </span>
                  </span>
                </span>
              </Link>
            </li>
          );
        })}
      </ol>
    </aside>
  );
}